import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import EnvironmentBanner from "../../assets/Environment.png";

const Environment = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Learning Environment - Shree Mangalam School"
        description="Discover the positive and disciplined learning environment at Shree Mangalam School that fosters academic excellence and overall student development."
        url="/environment"
        keywords="school environment, disciplined learning, positive classroom, academic atmosphere, Shree Manglam education environment"
      />

      <Header image={EnvironmentBanner} alt={"Environment Banner image"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Our Commitment to a Green and Sustainable Environment
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we understand that a
          nurturing environment is essential for fostering creativity, learning,
          and well-being. Our campus is designed to be an extension of nature,
          where green spaces, clean surroundings, and sustainable practices come
          together to create a safe and healthy environment for our students.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We believe that environmental education is as important as academic
          learning. Our school encourages students to develop a deep
          appreciation for nature and the planet, making them aware of their
          role in creating a sustainable future. With a focus on eco-friendly
          practices, such as waste segregation, water conservation, and energy
          efficiency, we aim to instill habits that contribute to a cleaner,
          greener world.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our lush gardens, tree plantation drives, and eco-clubs actively
          involve students in environmental preservation and community service.
          Every step we take towards a greener campus reinforces our commitment
          to shaping responsible global citizens who respect and protect their
          surroundings.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Creating an environmentally conscious future starts here. We aim to
          teach our students not only to excel academically but also to become
          stewards of the environment who make a positive impact on the world
          around them.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we don’t just teach — we
          inspire through every activity, every challenge, and every
          opportunity. Whether it’s on the sports field or in the classroom, we
          nurture courage, confidence, and character. Enroll now and let your
          child grow into a confident, capable, and compassionate individual —
          ready to take on the world.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Environment;
